import { join } from 'lodash'

const listToCommaSeparated = strings => join(strings, ', ')

export default listToCommaSeparated
